export default __webpack_public_path__ + "static/media/Avatar.6e74148e.png";